const birthDate = new Date().getFullYear() - 1994;
export const data = [
	{
		id: 1,
		name: 'Name',
		value: 'Aouni Chaker',
	},
	{
		id: 2,
		name: 'Age',
		value: birthDate,
	},
	{
		id: 3,
		name: 'Email',
		value: 'chykou87@gmail.com',
	},
	{
		id: 4,
		name: 'Phone',
		value: '+216 52 488 429',
	},
	{
		id: 5,
		name: 'Country',
		value: 'Tunisia',
	},
];
